<sh-toast-container></sh-toast-container>
<router-outlet />
<app-global-loader></app-global-loader>
